// TODO: Add the actual loading screen here
export function TerminalLoading(): React.ReactElement {
  return (
    <div className="terminal-loading">
      <div className="loading-container">
        <div className="loading-spinner">
          <div className="spinner-ring" />
        </div>
        <p className="loading-text">Loading...</p>
      </div>
    </div>
  );
}

export default TerminalLoading;
